<script setup lang="ts">
import { defineProps } from "vue";
import { CalendarDayParams } from "@/types/calculators";
import DayCardComponent from "@/views/Calculators/ChineseCalendar/components/DayCardComponent.vue";
import { useI18n } from "vue-i18n";

defineProps<{
  date: string;
  dayParams: CalendarDayParams;
}>();

const { t } = useI18n();
</script>

<template>
  <DayCardComponent>
    <template #card-title>
      <p class="text-white text-base md:text-xl xl:text-2xl font-semibold">
        {{ t("calculators.chinese-calendar-day.day-params.title") }}
      </p>
    </template>
    <template #card-content>
      <p class="card-content-row">
        {{ t("calculators.chinese-calendar-day.day-params.date") }}
        <span>{{ new Date(date).toLocaleDateString() }}</span>
      </p>
      <p class="card-content-row">
        {{ t("calculators.chinese-calendar-day.day-params.conform") }}
        <span>{{ dayParams.conform }}</span>
      </p>
      <p class="card-content-row">
        {{ t("calculators.chinese-calendar-day.day-params.no-conform") }}
        <span>{{ dayParams.no_conform }}</span>
      </p>
      <p class="card-content-row">
        {{ t("calculators.chinese-calendar-day.day-params.year") }}
        <span>{{ dayParams.year_animal }}</span>
      </p>
      <p class="card-content-row">
        {{ t("calculators.chinese-calendar-day.day-params.month") }}
        <span>{{ dayParams.month_animal }}</span>
      </p>
      <p class="card-content-row">
        {{ t("calculators.chinese-calendar-day.day-params.day") }}
        <span>{{ dayParams.day_animal }}</span>
      </p>
    </template>
  </DayCardComponent>
</template>

<style scoped>
.card-content-row {
  @apply text-left font-medium text-lg md:text-xl text-brown;
  span {
    @apply font-semibold;
  }
}
</style>
